// extracted by mini-css-extract-plugin
module.exports = {"visible":"visible__sH9fG","bff-show":"bff-show__ns5b-","h6":"h6__cwYEm","p":"p__chlMv","bff-tool-tip":"bff-tool-tip__zmeK0","noMargin":"noMargin__KvBNu","tooltip":"tooltip__amccS"};